/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type listGroupQueryVariables = {|
  queryParams: string,
  userGroupsAndTenantsQuery: string,
  groupUuid: string,
|};
export type listGroupQueryResponse = {|
  +userGroupsV2: ?$ReadOnlyArray<?{|
    +groups: ?$ReadOnlyArray<?string>,
    +email: ?string,
    +_tenantUuid: ?string,
  |}>,
  +groupsV2: ?$ReadOnlyArray<?{|
    +tenantUuid: string,
    +groups: ?$ReadOnlyArray<?{|
      +uuid: string,
      +name: string,
      +userCount: ?string,
      +_audit: ?{|
        +createdAt: ?string
      |},
      +status: ?string,
    |}>,
  |}>,
|};
export type listGroupQuery = {|
  variables: listGroupQueryVariables,
  response: listGroupQueryResponse,
|};
*/


/*
query listGroupQuery(
  $queryParams: String!
  $userGroupsAndTenantsQuery: String!
  $groupUuid: String!
) {
  userGroupsV2(userIds: $userGroupsAndTenantsQuery, tenantUuid: $groupUuid) {
    groups
    email
    _tenantUuid
  }
  groupsV2(tenantUuids: $queryParams, tenant: $groupUuid) {
    tenantUuid
    groups {
      uuid
      name
      userCount
      _audit {
        createdAt
      }
      status
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupUuid"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryParams"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userGroupsAndTenantsQuery"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "tenantUuid",
        "variableName": "groupUuid"
      },
      {
        "kind": "Variable",
        "name": "userIds",
        "variableName": "userGroupsAndTenantsQuery"
      }
    ],
    "concreteType": "UserGroupsV2",
    "kind": "LinkedField",
    "name": "userGroupsV2",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "groups",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "_tenantUuid",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "tenant",
        "variableName": "groupUuid"
      },
      {
        "kind": "Variable",
        "name": "tenantUuids",
        "variableName": "queryParams"
      }
    ],
    "concreteType": "GroupsV2",
    "kind": "LinkedField",
    "name": "groupsV2",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tenantUuid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GroupV2",
        "kind": "LinkedField",
        "name": "groups",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uuid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Audit",
            "kind": "LinkedField",
            "name": "_audit",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "listGroupQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "listGroupQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "45826a0a8c03e307670ea7c79f698d8e",
    "id": null,
    "metadata": {},
    "name": "listGroupQuery",
    "operationKind": "query",
    "text": "query listGroupQuery(\n  $queryParams: String!\n  $userGroupsAndTenantsQuery: String!\n  $groupUuid: String!\n) {\n  userGroupsV2(userIds: $userGroupsAndTenantsQuery, tenantUuid: $groupUuid) {\n    groups\n    email\n    _tenantUuid\n  }\n  groupsV2(tenantUuids: $queryParams, tenant: $groupUuid) {\n    tenantUuid\n    groups {\n      uuid\n      name\n      userCount\n      _audit {\n        createdAt\n      }\n      status\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '67d5fc30897bfa87d0bf3582e8278c1e';

module.exports = node;
